import { Link } from 'react-router-dom';
import { CalendarDays, MapPin, Newspaper } from 'lucide-react';
import { Badge } from './ui/badge';
import { Post, POST_KIND_LABELS, postDateLabel } from '../types/post';

/** Scheda di un evento, una novità o un articolo: in /novita e in home. */
export default function PostCard({ post }: { post: Post }) {
  const isEvent = post.kind === 'evento';
  return (
    <Link
      to={`/novita/${post.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-shadow hover:shadow-lg"
    >
      <div className="relative h-52 overflow-hidden bg-muted">
        {post.image_url ? (
          <img
            src={post.image_url}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-primary/60">
            {isEvent ? <CalendarDays className="h-12 w-12" /> : <Newspaper className="h-12 w-12" />}
          </div>
        )}
        <Badge variant="secondary" className="absolute left-3 top-3">
          {POST_KIND_LABELS[post.kind]}
        </Badge>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold text-primary">
          <CalendarDays className="h-3.5 w-3.5 flex-none" />
          {postDateLabel(post)}
        </p>
        <h3 className="mb-2 font-display text-xl font-semibold text-foreground">{post.title}</h3>
        <p className="line-clamp-3 flex-1 text-sm text-muted-foreground">{post.summary}</p>
        {isEvent && post.location && (
          <p className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-muted-foreground">
            <MapPin className="h-3.5 w-3.5 flex-none" />
            {post.location}
          </p>
        )}
      </div>
    </Link>
  );
}
